import { createContext, useContext, useState } from 'react'

const ModalContext = createContext()

export function ModalProvider({ children, pagarmePublicKey = null }) {
  const [isOpen, setIsOpen] = useState(false)
  const [plan, setPlan] = useState(null)
  const [planId, setPlanId] = useState(null)

  return (
    <ModalContext.Provider value={{
      isOpen,
      plan,
      planId,
      pagarmePublicKey,
      openModal: (planName = null, id = null) => { setPlan(planName); setPlanId(id); setIsOpen(true) },
      closeModal: () => setIsOpen(false),
    }}>
      {children}
    </ModalContext.Provider>
  )
}

export function useModal() {
  return useContext(ModalContext)
}
